/**
 * Created by jv on 06/02/2017.
 */
const utils = require("Sources/utils/utils");
const ElementCreator = require("Sources/components/element-creator");
const FormTemplate = require("Sources/templates/form.template");
// const FormGroupTemplate = require("Sources/templates/form-group.template");

//styles
require("Styles/components/form-dialog.scss");

module.exports = class DialogFormTemplate
{
  constructor(options)
  {
    /*
     * options.dialogId
     * options.title
     * options.disposable
     *
     * options.formData (data to make the FormGroupTemplates)
     *
     * options.submitText
     * options.cancelText (if null --> no cancel button)
     *
     * options.onSubmit
     * options.onCancel
     */

    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.dialogId = options.dialogId;
    this.backdropIdSuffix = "-modal-backdrop";
    this.title = options.title;
    this.description = options.description;
    this.disposable = utils.isBoolean(options.disposable) ? options.disposable : true;

    this.formData = options.formData;

    this.submitDisabled = utils.isBoolean(options.submitDisabled) ? options.submitDisabled : false;
    this.submitText = options.submitText;
    this.submitWidth = options.submitWidth;
    this.cancelText = options.cancelText;
    this.cancelPosition = options.cancelPosition;

    this.onSubmit = options.onSubmit;
    this.onCancel = options.onCancel;

    this.formTemplate = null;

    this.create();
  }

  set submitDisabled(flag)
  {
    this._submitDisabled = flag;

    if(utils.isNotNull(this.dialogEl) && this.dialogEl.length)
    {
      var submitBtn = this.dialogEl.find(".dft-submit-btn");;

      if(utils.isNotNull(submitBtn) && submitBtn.length)
      {
        submitBtn.prop("disabled", this.submitDisabled);

        if(this.submitDisabled && !submitBtn.hasClass("disabled"))
        {
          submitBtn.addClass("disabled");
        }
        else
        {
          submitBtn.removeClass("disabled");
        }
      }
    }
  }

  get submitDisabled()
  {
    return this._submitDisabled;
  }

  get backdropId()
  {
    return this.dialogId + this.backdropIdSuffix;
  }

  get backdropExists()
  {
    return $("#" + this.backdropId).length;
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.renderDialog();
      this.renderTitle();
      this.renderDescription();
      this.renderFormWrapper();
      this.renderButtons();

      this.backdrop = ElementCreator.createStringElement({
        classNames: [ "modal-backdrop", "fade", "in" ],
        attributes: [ { name: "id", value: this.backdropId }]
      });

      this.addToDOM();

      if(this.disposable)
      {
        this.addDisposeListener();
      }

      this._initialized = true;
    }
  }

  renderDialog()
  {
    this.dialogEl = $("<div id='" + this.dialogId + "' class='modal fade' style='display: block;'>" +
                        "<div class='modal-dialog'>" +
                          "<div class='modal-content clearfix'>" +
                          "</div>" +
                        "</div>" +
                      "</div>");
  }

  renderTitle()
  {
    this.dialogEl.find(".modal-content").append("<h3 class='dialog-title'>" + this.title + "</h3>");
  }

  renderDescription()
  {
    if(!utils.isNullOrEmpty(this.description))
    {
      this.dialogEl.find(".modal-content").append("<p class='dialog-description'>" + this.description + "</p>");
    }
  }

  renderFormWrapper()
  {
    if(utils.isNull(this.formTemplate))
    {
      this.formTemplate = new FormTemplate({
        formId: this.dialogId + "-form",
        appendTo: this.dialogEl.find(".modal-content"),
        formData: this.formData
      });

      this.formData = null;
    }
    else
    {
      this.formTemplate.rerender();
    }
  }

  renderButtons()
  {
    var that = this;
    var buttonWrapper = $("<div class='button-wrapper clearfix'></div>");

    if(utils.isNotNull(that.cancelText) || that.cancelPosition === "top-right")
    {
      var classNames = [ "btn", "btn-main", "no-icon", "pull-right" ];
      var innerHTML = that.cancelText;

      if(that.cancelPosition === "top-right")
      {
        classNames = [ "btn", "btn-icon", "frameless", "cross-circle", "dark-grey", "pull-right" ];
        innerHTML = null;
      }

      var cancelBtn = $(ElementCreator.createStringElement({
        tagName: "button",
        classNames: classNames,
        attributes: [
          { name: "type", value: "button" }
        ],
        innerHTML: innerHTML
      }));

      cancelBtn.on("click", function()
      {
        that.cancel();
      });

      if(that.cancelPosition === "top-right")
      {
        this.dialogEl.find(".modal-content").prepend(cancelBtn);
      }
      else
      {
        buttonWrapper.append(cancelBtn);
      }
    }

    var submitBtn = $("<button class='btn btn-main no-icon pull-right dft-submit-btn' type='button'>" + that.submitText + "</button>");

    if(utils.isNotNull(that.submitWidth))
    {
      submitBtn.css("width", that.submitWidth);
    }

    if(this.submitDisabled === true)
    {
      submitBtn.prop("disabled", true).addClass("disabled");
    }

    submitBtn.on("click", function(e)
    {
      if(this.submitDisabled === true)
      {
        e.preventDefault();
        return;
      }

      if(utils.isFunction(that.onSubmit))
      {
        that.onSubmit(that.formTemplate.getDataObject());
      }
    });

    buttonWrapper.append(submitBtn);
    this.dialogEl.find(".modal-content").append(buttonWrapper);
  }

  cancel()
  {
    this.close();

    if(utils.isFunction(this.onCancel))
    {
      this.onCancel();
    }
  }

  reset()
  {
    this.formTemplate.reset();
  }

  validate()
  {
    return this.formTemplate.validate();
  }

  getFormGroupForKey(key)
  {
    if(utils.isNotNull(this.formTemplate))
    {
      return this.formTemplate.getFormGroupForKey(key);
    }

    return null;
  }

  show()
  {
    this.open();
  }

  open()
  {
    var $body = $("body");
    if(!$body.hasClass("modal-open"))
    {
      $body.addClass("modal-open");
    }

    if(!this.backdropExists)
    {
      $body.append(this.backdrop);
    }

    // Reading a css property forces layout to be computed
    this.dialogEl.css("width");
    this.dialogEl.addClass("in");
  }

  hide()
  {
    this.close();
  }

  close(callback)
  {
    var $body = $("body");
    if($body.hasClass("modal-open"))
    {
      $body.removeClass("modal-open");
    }

    $("#" + this.backdropId).remove();

    this.dialogEl.removeClass("in");

    var that = this;
    setTimeout(function()
    {
      that.dialogEl.hide();

      if(utils.isFunction(callback))
      {
        callback();
      }
    }, 150);
  }

  destroy()
  {
    var that = this;
    if(that._destroying !== true)
    {
      that._destroying = true;
      that.close(function()
      {
        that.formTemplate.destroy();
        that.dialogEl.remove();
        that._initialized = false;
        that._destroying = false;
      });
    }
  }

  addDisposeListener()
  {
    var that = this;

    that.dialogEl.off().on("click", function(e)
    {
      if(e.target.className === "modal-content" || $(e.target).closest(".modal-content").length)
      {
        e.stopPropagation();
        return;
      }

      that.cancel();
    });
  }

  addToDOM()
  {
    this.dialogEl.appendTo("body");
  }
};



// WEBPACK FOOTER //
// ./app/js/templates/dialog-form.template.js